/**
 * Top Responses Widget
 * Surfaces the most-liked responses to today's prompt to pull readers in.
 * ponytail: ranks client-side from the prompt's posts (no dedicated endpoint);
 * swap to a server-side sorted/limited query if the prompt ever has many posts.
 */

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import axios from 'axios';

const TopResponsesWidget = ({ prompt }) => {
  const [top, setTop] = useState([]);

  useEffect(() => {
    if (!prompt?._id) return undefined;
    let active = true;
    axios
      .get('/api/posts', { params: { promptId: prompt._id } })
      .then((res) => {
        if (!active) return;
        const ranked = (res.data || [])
          .filter((p) => !p.repostOf && (p.likes?.length || 0) > 0)
          .sort((a, b) => (b.likes?.length || 0) - (a.likes?.length || 0))
          .slice(0, 2);
        setTop(ranked);
      })
      .catch(() => { /* ignore */ });
    return () => { active = false; };
  }, [prompt?._id]);

  if (top.length === 0) return null;

  return (
    <div className="prompt-widget">
      <span className="widget-title widget-title-block">Top responses today</span>
      <div className="top-responses">
        {top.map((post, i) => (
          <Link key={post._id} to={`/post/${post._id}`} className="top-response-row">
            <span className="top-response-rank">{i + 1}</span>
            <span className="top-response-body">
              <span className="top-response-snippet">{post.content}</span>
              <span className="top-response-meta">
                @{post.author?.username} · <Heart size={11} /> {post.likes?.length || 0}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default TopResponsesWidget;
